import { makeStyles, Theme } from '@material-ui/core';

const useContentFilterStyles = makeStyles((theme: Theme) => ({
  containerBottom: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    marginTop:"10px",
  },
  containerSwithces: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  icon: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(-0.3),
  },
  iconOrg: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(-0.1),
  },
  lockSwitch: {
    "&$checked": {
      color: "yellow",
    },
  },
  maxWidth: {
    width: '10px'
  },
  tutorialIconStyle: {
    display: 'flex',
    alignContent: 'flex-start',
    marginLeft: 20
  },
  FormControlLabelSw: { marginLeft: 4, flexGrow: 1, flexShrink: 0, fontWeight: 500 },
  gridCenter: { alignSelf: "center", paddingLeft: 8 },
  flexEndPaddingR8: { display: "flex", justifyContent: "flex-end", paddingRight: 8 },
  fGrow1MTop10: { flexGrow: 1, marginTop: 10 },
  controllerBox: { display: "flex", flexDirection: "row" },
  formControlLabelStyle: { marginLeft: 4, flexGrow: 1, flexShrink: 0, width: "100%" },
  infoIconStyle: { color: theme.palette.text.primary, marginLeft: -15, cursor: "pointer" },
}));

export default useContentFilterStyles;
